import React, { useEffect, useState } from "react";
import AdminContainer from "../../components/ui/AdminContainer";
import RemoteTable from "../../components/ui/RemoteTable";
// import { isMultiYear } from "../../services/defaultSettings";
// import { getYearPlaceHolder } from "../../services/yearSevices";
import { printFullDate } from "../../utils/time";
import Button from "../../components/ui/Button";
import { baseURL } from "../../config";
import InputField from "../../components/form/elements/InputField";
import { handleInputChange } from "../../services/formServices";
import { insertAutos } from "../../services/defaultSettings";

let links = {
    excel: `${baseURL}/insert_auto/`,
    // "front-1": `${baseURL}/insert_auto_card/front/1/`,
    // "back-1": `${baseURL}/insert_auto_card/back/1/`,
    // "front-2": `${baseURL}/insert_auto_card/front/2/`,
    // "back-2": `${baseURL}/insert_auto_card/back/2/`,
    // "front-3": `${baseURL}/insert_auto_card/front/3/`,
    "back-3": `${baseURL}/insert_auto_card/back/3/`,
    "back-4": `${baseURL}/insert_auto_card/back/4/`,
    "front-4": `${baseURL}/insert_auto_card/front/4/`,
    "back-5": `${baseURL}/insert_auto_card/back/5/`,
    "front-5": `${baseURL}/insert_auto_card/front/5/`,
    "back-6": `${baseURL}/insert_auto_card/back/6/`,
    "front-6": `${baseURL}/insert_auto_card/front/6/`,
    "back-7": `${baseURL}/insert_auto_card/back/7/`,
    "front-7": `${baseURL}/insert_auto_card/front/7/`,
    "back-8": `${baseURL}/insert_auto_card/back/8/`,
    "front-8": `${baseURL}/insert_auto_card/front/8/`,
    "back-9": `${baseURL}/insert_auto_card/back/9/`,
    "front-9": `${baseURL}/insert_auto_card/front/9/`,
    "back-10": `${baseURL}/insert_auto_card/back/10/`,
    "front-10": `${baseURL}/insert_auto_card/front/10/`,
    "back-11": `${baseURL}/insert_auto_card/back/11/`,
    "front-11": `${baseURL}/insert_auto_card/front/11/`,
    "back-12": `${baseURL}/insert_auto_card/back/12/`,
    "front-12": `${baseURL}/insert_auto_card/front/12/`,
};
let placeHolders = {
    excel: "عرض اكسل",
    // "front-1": "عرض كارت ١ - مقدمة",
    // "back-1": "عرض كارت ١ - خلفية",
    // "front-2": "عرض كارت 2 - مقدمة",
    // "back-2": "عرض كارت 2 - خلفية",
    "back-3": "كارت وليد محسن ازرق",
    "front-4": "عرض كارت أستاذي - مقدمة",
    "back-4": "عرض كارت أستاذي - خلفية",
    "front-5": "عرض كارت الحق نفسك - مقدمة",
    "back-5": "عرض كارت الحق نفسك - خلفية",
    "front-6": "عرض كارت صفحة الحق نفسك - مقدمة",
    "back-6": "عرض كارت صفحة الحق نفسك - خلفية",
    "front-7": "عرض كارت صفحة عام ٢ث - مقدمة",
    "back-7": "عرض كارت صفحة عام ٢ث - خلفية",
    "front-8": "عرض كارت صفحة عام ١ث - مقدمة",
    "back-8": "عرض كارت صفحة عام ١ث - خلفية",
    "front-9": "عرض كارت صفحة طلبة الصعيد - مقدمة",
    "back-9": "عرض كارت صفحة طلبة الصعيد - خلفية",
    "front-10": "عرض كارت كورس مراجعة الترم - مقدمة",
    "back-10": "عرض كارت كورس مراجعة الترم - خلفية",
    "front-11": "عرض كارت كورس الترم - مقدمة",
    "back-11": "عرض كارت كورس الترم - خلفية",
    "front-12": "عرض كارت النصوص المتحررة - مقدمة",
    "back-12": "عرض كارت النصوص المتحررة - خلفية",
};

let options = [
    { value: "excel", text: placeHolders.excel },
    // { value: "front-1", text: placeHolders["front-1"] },
    // { value: "back-1", text: placeHolders["back-1"] },
    // { value: "front-2", text: placeHolders["front-2"] },
    // { value: "back-2", text: placeHolders["back-2"] },
    { value: "back-3", text: placeHolders["back-3"] },
    { value: "front-4", text: placeHolders["front-4"] },
    { value: "back-4", text: placeHolders["back-4"] },
    { value: "front-5", text: placeHolders["front-5"] },
    { value: "back-5", text: placeHolders["back-5"] },
    { value: "front-6", text: placeHolders["front-6"] },
    { value: "back-6", text: placeHolders["back-6"] },
    { value: "front-7", text: placeHolders["front-7"] },
    { value: "back-7", text: placeHolders["back-7"] },
    { value: "front-8", text: placeHolders["front-8"] },
    { value: "back-8", text: placeHolders["back-8"] },
    { value: "front-9", text: placeHolders["front-9"] },
    { value: "back-9", text: placeHolders["back-9"] },
    { value: "front-10", text: placeHolders["front-10"] },
    { value: "back-10", text: placeHolders["back-10"] },
    { value: "front-11", text: placeHolders["front-11"] },
    { value: "back-11", text: placeHolders["back-11"] },
    { value: "front-12", text: placeHolders["front-12"] },
    { value: "back-12", text: placeHolders["back-12"] },
];

Object.keys(insertAutos).forEach((value, index) => {
    links[value] = insertAutos[value].link;
    placeHolders[value] = insertAutos[value].name;
    options.push({ value, text: insertAutos[value].name });
});

const InsertAutos = () => {
    const [cardTheme, setCardTheme] = useState({
        text: options[0].text,
        link: links[options[0].value],
    });
    const [data, setData] = useState({ theme: "excel" });
    useEffect(() => {
        setCardTheme({
            text: placeHolders[data.theme],
            link: links[data.theme],
        });
    }, [data.theme]);
    let columns = [
        {
            name: "التسلسل",
            reorder: true,
            selector: (row) => row.id,
            sortable: true,
            sortField: "id",
        },
        {
            name: "العنوان",
            reorder: true,
            selector: (row) => row.name,
            sortable: true,
            sortField: "name",
        },
        {
            name: "عدد الأكواد",
            reorder: true,
            selector: (row) => row.quantity,
            sortable: true,
            sortField: "duration",
        },
        {
            name: "من",
            reorder: true,
            // selector: (row) => row.insert_log.from,
            selector: (row) => row.number_from,
            sortable: true,
            sortField: "number_from",
        },
        {
            name: "إلى",
            reorder: true,
            selector: (row) => row.number_to,
            sortable: true,
            sortField: "number_to",
        },
        {
            name: "تاريخ الإضافة",
            reorder: true,
            selector: (row) => printFullDate(row.created_at),
            sortable: true,
            sortField: "created_at",
        },
        {
            name: "الأكواد",
            reorder: true,
            selector: (row) => (
                <div>
                    <Button
                        className="block"
                        element="a"
                        target="_blank"
                        href={`${cardTheme.link}${row.id}`}
                    >
                        {cardTheme.text}
                    </Button>
                </div>
            ),
            sortable: true,
            sortField: "created_at",
        },
    ];

    return (
        <AdminContainer>
            <div className="flex-center-both flex-col w-full space-y-6">
                <div className="text-center">طريقة عرض الأكواد ؟</div>
                <div className="w-full max-w-2xl">
                    <InputField
                        type="select"
                        data={data}
                        setData={setData}
                        id="theme"
                        onChange={handleInputChange}
                        options={options}
                    />
                </div>
            </div>
            <div className="w-full">
                <RemoteTable api={`/api/insert_autos/paginate`} columns={columns} />
            </div>
        </AdminContainer>
    );
};

export default InsertAutos;
